module.exports = __webpack_public_path__ + "static/media/insulation_gwp_10y_n.ceb98b5e.csv";